<template>
    <div class="empSearch">

        <v-card>
            <v-snackbar
                    v-model="snackbar.show"
                    color="red"
                    :timeout="6000"
                    top
                    multi-line
            >
                <div class="white--text"><v-icon light class="white--text">mdi-alert</v-icon>&nbsp;&nbsp;{{ snackbar.msg }}</div>
                <v-btn
                        dark
                        flat
                        @click="snackbar.show = false"
                >
                    Close
                </v-btn>
            </v-snackbar>
        </v-card>

        <!-- หน้าบันทึกสำเร็จ -->
        <eva-thankyou  v-if="current_state=='thankyou'" @back_to_emp="back_to_emp" :back_btn="true" />
        <!-- หน้าส่ง Email สำเร็จ -->
        <eva-email-sent v-else-if="current_state=='email'" @back_to_emp="back_to_emp" />
        <!-- หน้าสร้าง QR code -->
        <eva-qrcode v-else-if="current_state=='qrcode'" :qrcode_uri="qrcode_uri" @back_to_emp="back_to_emp" />

        <!-- หน้ารายการประเมิน -->
        <div v-else>
            <div class="mt-5 text-xs-center" v-if="!question_list.hasOwnProperty('row_data')">Loading....please wait</div>
            <error-landing  v-else-if="question_list.hasOwnProperty('row_data')&&question_list.row_data==0" :msg="error_msg"/>
            <div v-else>
                <div class="text-xs-center mt-4 blue--text">
                    <h2>
                    <!--<v-icon class="blue&#45;&#45;text">mdi-star</v-icon>-->
                    ประเมินฝ่าย {{ selected_service.dept_code }}</h2>
                    <p class="black--text"><span class="font-weight-bold">ผู้ถูกประเมิน : </span>{{ data_staff.FULL_NAME }} ({{ data_staff.EORG_04 }})</p>
                </div>
                <v-flex xs12 sm8 md6 offset-md3 offset-sm2>
                    <v-layout row wrap class="mt-3">
                        <v-card v-for="(question,index) in question_list.result" class=" mb-3 pa-2 pt-3 pb-3 each_question">
                            <div class="text-xs-left body-2">
                                <!--{{ index+1 }}.-->
                                {{ question.question_desc }}
                            </div>
                            <rating-star :question_id="question.question_id"  @set_score="setScore"/>
                        </v-card>
                    </v-layout>
                </v-flex>
                <div class="text-xs-center mt-3">
                    <p class="black--text subheading"><span class="font-weight-bold">ผู้ประเมิน : </span>{{ selected_emp.FULL_NAME_SERACH }} ({{ selected_emp.EORG_04 }})</p>
                    <v-flex xs6 sm2 md2 offset-md5 offset-sm5 offset-xs3>
                        <v-btn color="success" large  block class="font-weight-bold mt-3" @click="saveScore()" :disabled="save_btn_disabled">บันทึก</v-btn>
                        <v-btn color="info" large block class="font-weight-bold mt-3" @click="sendto('email')"><v-icon left>mdi-telegram</v-icon>ส่ง Email</v-btn>
                        <v-btn color="info" large block class="font-weight-bold mt-3" @click="sendto('qrcode')"><v-icon left>mdi-qrcode</v-icon>แสดง QR Code</v-btn>
                    </v-flex>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '@/EventBus'
    import axios from '@/axios'
    import RatingStar from '@/components/RatingStar'
    import EvaThankyou from '@/components/after_evaluate/EvaThankyou'
    import EvaEmailSent from '@/components/after_evaluate/EvaEmailSent'
    import EvaQrcode from '@/components/after_evaluate/EvaQrcode'
    import ErrorLanding from '@/components/ErrorLanding'
    import qs from 'qs'

    export default {
        name: "EmpEvaluate",
        components:{
            ratingStar:RatingStar,
            evaThankyou:EvaThankyou,
            evaEmailSent:EvaEmailSent,
            evaQrcode:EvaQrcode,
            errorLanding:ErrorLanding,
        },
        props:{
            selected_service:Object,
            selected_emp:Object,
        },
        data(){
            return{
                localitem:this.getLocalItem(),
                question_list:[],
                data_staff:{},
                question_origin:[],
                eva_score:[],
                question_id:[],
                snackbar:{
                    show:false,
                    msg:"Alert"
                },
                current_state:'evaluate',
                qrcode_uri:'qrcode',
                error_msg:'error',
                save_btn_disabled:true,
                //line_token:'fEFse0aoM9oI09jotrtllz6W1okMt2E61tmP1HDcgAW'
                line_token:'Dnsv7q6iaTr0Nv6HgYWPh1ZrUiXcmNkJnSUec9ktd2P'
            }
        },
        async created() {
            await this.getDataStaff()
            await this.getQuestion()
        },
        mounted(){

            window.scrollTo(0,0)
            EventBus.$emit('set_navigation', {title:'เลือกพนักงาน',back_route:'evaluate',params:{eventbus_call:'clear_selected_emp'}})
        },
        methods:{
            setScore(qs){
                if(!this.question_id.includes(qs.question_id)) {
                    this.question_id.push(qs.question_id)
                    this.eva_score.push(qs.score)
                }else{
                    let idx = this.question_id.findIndex(k => k===qs.question_id)
                    this.eva_score[idx] = qs.score
                }

                if(this.question_origin.length!=this.question_id.length) {
                    this.save_btn_disabled = true
                }else{
                    this.save_btn_disabled = false
                }

            },
            async getQuestion()
            {
                try{
                    const uri = '/GetQuestion'
                    const res = await axios.post(uri, {
                        service_id:this.selected_service.serviceD_id
                    })

                    this.question_list = res.data
                    this.question_origin = res.data.result.map(rows=>(
                        rows.question_id
                    ))
                    if(res.data.row_data==0){
                        this.error_msg = 'ไม่พบคำถามที่ใช้ในการประเมิน'
                    }
                }catch(err)
                {
                    this.question_list = []
                    console.log(err.message)
                }
            },
            async getDataStaff()
            {
                try{
                    const uri = '/getDataStaff'
                    const res = await axios.post(uri, {
                        query_value:this.localitem.user_id,
                        field_type:'USERNAME'
                    })
                    if(res.data.status=='ok') {
                        this.data_staff = res.data.result
                    }else{
                        this.data_staff = {}
                    }
                }catch(err)
                {
                    this.data_staff = {}
                    console.log(err.message)
                }
            },
            async saveScore(){
                if(this.question_origin.length!=this.question_id.length){
                    this.snackbar.show = true
                    this.snackbar.msg = "กรุณาทำประเมินให้ครบทุกข้อค่ะ!!"
                    return false
                }else {
                    this.save_btn_disabled = true

                    try {
                        const uri = '/saveEvaluate'
                        let obj = {
                            username: this.localitem.user_id,
                            em_code: this.selected_emp.EM_CODE,
                            service_id: this.selected_service.serviceD_id,
                            question_id: this.question_id,
                            point: this.eva_score,
                            service_dept_id: this.selected_service.dept_id,
                            service_dept_code: this.selected_service.dept_code
                        }
                        // console.log('obj  ieiei',obj)
                        // return
                        const res = await axios.post(uri, obj)

                        if(res.data.status=='ok'){
                            this.current_state = 'thankyou'

                            if(this.selected_service.dept_code=='MIS'&&this.eva_score<10) {
                                let do_service_date =  this.$moment(new Date()).format("DD/MM/YYYY เวลา HH:mm น.")
                                let msg = ""
                                msg += "แจ้งเตือนมีผู้ถูกประเมินฝ่าย MIS ได้คะแนนต่ำกว่า 10"
                                msg += "\nผู้ถูกประเมิน : " + this.data_staff.FULL_NAME + " (" + this.data_staff.EM_NICKNAME + ")"
                                //msg += "\nผู้ประเมิน : " + this.selected_emp.FULL_NAME_SERACH + " (" + this.selected_emp.EM_NICKNAME + " " + this.selected_emp.EORG_04 + ")"
                                msg += "\nคะแนนที่ได้ : " + this.eva_score
                                msg += "\nเรื่องที่ประเมิน : " + this.selected_service.serviceD_name
                                msg += "\nวันที่ให้บริการ : " + do_service_date
                                this.sendLineNotify(msg)
                            }

                        }else{
                            this.current_state = 'evaluate'
                        }

                    } catch (err) {
                        console.log(err.message)
                    }

                    this.save_btn_disabled = false
                }
            },
            async sendLineNotify(msg){
                try {

                    const res = axios.post('https://us-central1-line-api-6e025.cloudfunctions.net/lineNotify', null, { params: {
                        token:this.line_token,
                        message: msg
                    }})
                    if (res){
                        console.log(res)
                    }

                } catch (err) {
                    console.log(err.message)
                }

            },
            back_to_emp(){
                EventBus.$emit('clear_selected_emp')
            },
            async sendto(send_chanel){
                let error_msg_text = send_chanel=='email' ? 'เกิดข้อผิดพลาด ไม่สามารถส่ง Email ได้!!':'เกิดข้อผิดพลาด ไม่สามารถสร้าง QR Code ได้'
                let eva_prop = {
                    username:this.localitem.user_id,//คนที่ถูกประเมิน คนที่ login App อยู่
                    em_code:this.selected_emp.EM_CODE,//รหัสพนักงานผู้ที่ประเมิน คนที่ต้องการส่งลิงค์
                    service_id:this.selected_service.serviceD_id,
                    service_dept_id: this.selected_service.dept_id,
                    service_dept_code: this.selected_service.dept_code
                }

                try {
                    const uri = send_chanel=='email' ? '/serviceSendEmail':'/createURI'
                    const res = await axios.post(uri, eva_prop)

                    if(res.data.status=='ok'){
                        if(send_chanel=='email'){
                            this.current_state = 'email'
                        }else{
                            this.qrcode_uri = 'https://mobileapps.lpn.co.th/service-excellence/#/eval?code='+res.data.code
                            this.current_state = 'qrcode'
                        }
                    }else{
                        this.current_state = 'evaluate'
                        this.snackbar.show = true
                        this.snackbar.msg = error_msg_text
                        return false
                    }


                } catch (err) {
                    console.log(err.message)
                }
            }
        }
    }
</script>

<style scoped>
    .each_question{
        border-radius: 10px;
        width: 100%;
    }
</style>